module.exports = __webpack_public_path__ + "img/10.6c5c6047.jpg";